/**
 * Action Types
 */
export var USER_DETAILS = 'USER/DETAILS';
export var USER_ACCOUNTS = 'USER/ACCOUNTS';
export var USER_USERS = 'USER/USERS';